import type { FaqItem } from "@/components/editorial/faq";

import { STARTING_PRICES } from "../../pricing/pricing-data";

/** The connector marks the solution pages share. */
export const LOGO = {
  drive: { name: "Google Drive", logo: "/concepts/source-icons/google-drive.png" },
  github: { name: "GitHub", logo: "/concepts/source-icons/github.png" },
  hubspot: { name: "HubSpot", logo: "/concepts/source-icons/hubspot.svg" },
  linear: { name: "Linear", logo: "/concepts/source-icons/linear.png" },
  outlook: { name: "Outlook", logo: "/concepts/source-icons/outlook.svg" },
  sharepoint: { name: "SharePoint", logo: "/concepts/source-icons/sharepoint.svg" },
  sheets: { name: "Google Sheets", logo: "/concepts/source-icons/google-sheets.png" },
  slack: { name: "Slack", logo: "/concepts/source-icons/slack.png" },
  sunsystems: { name: "SunSystems", logo: "/concepts/source-icons/sunsystems.svg" },
  xero: { name: "Xero", logo: "/concepts/source-icons/xero.svg" },
} as const;

/*
 * The questions a sector page answers after its own: access, hosting,
 * accuracy, effort and cost, in claims the home and /faq already make. A
 * sector passes a sharper question of its own in place of one of them.
 */

export const ACCESS_QUESTION: FaqItem = {
  q: "Who can see the records?",
  a: "Connections start read-only and access is limited to your organisation. Each person sees the records their access allows, and we agree who that is with you before setup.",
};

export const HOSTING_QUESTION: FaqItem = {
  q: "Where does it run?",
  a: "On a dedicated server for your organisation, in the EU or the US today; a UK-hosted option is in development. Requests to an AI model go to the provider configured for your organisation.",
};

export const ACCURACY_QUESTION: FaqItem = {
  q: "How do we know the answers are right?",
  a: "Your Twin’s calculations are tested against your source records, and work that fails the checks is left out. Checked answers show the sources and calculation they used, and when the Twin can’t support a question, it says so.",
};

export const EFFORT_QUESTION: FaqItem = {
  q: "What does our team need to do?",
  a: "Choose one review and agree access to the systems behind it. Over two focused weeks, Mercury Labs connects them, and your team agrees the definitions and checks the results against real examples before switching it on.",
};

export const COST_QUESTION: FaqItem = {
  q: "What does it cost?",
  a: `Core starts at ${STARTING_PRICES.core} a month, including a dedicated, managed deployment. AI usage starts at ${STARTING_PRICES.credits} a month, and optional engineering is ${STARTING_PRICES.engineeringDay} a day. We agree the work and costs with you before starting.`,
};
